
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiParametriGlobaliDialog extends Serenity.EntityDialog<ProdottiParametriGlobaliRow, any> {
        protected getFormKey() { return ProdottiParametriGlobaliForm.formKey; }
        protected getIdProperty() { return ProdottiParametriGlobaliRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiParametriGlobaliRow.localTextPrefix; }
        protected getNameProperty() { return ProdottiParametriGlobaliRow.nameProperty; }
        protected getService() { return ProdottiParametriGlobaliService.baseUrl; }
        protected getDeletePermission() { return ProdottiParametriGlobaliRow.deletePermission; }
        protected getInsertPermission() { return ProdottiParametriGlobaliRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiParametriGlobaliRow.updatePermission; }

        protected form = new ProdottiParametriGlobaliForm(this.idPrefix);

    }
}